<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h630_dialog abow_dialog"
      width="1300px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="绩效条数"
                  prop="infoCount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.infoCount"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="绩效总金额"
                  prop="performanceTotal"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.performanceTotal"
                    disabled
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="绩效扣除总金额"
                  prop="deductTotal"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.deductTotal"
                    disabled
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="实发绩效总金额"
                  prop="realPerformanceTotal"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.realPerformanceTotal"
                    disabled
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            人员绩效明细汇总
          </h3>
          <div class="modal-row-box">
            <el-row
              :gutter="10"
              style="margin-bottom:10px;"
            >
              <el-col :span="24">
                <el-table
                  :data="infoListData"
                  class="public-table"
                  :header-cell-style="{background:'#0076ff'}"
                  style="width: 100%"
                  border
                >
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-table
                        :data="props.row.infoList"
                        class="public-table"
                        :header-cell-style="{background:'#00c5cc'}"
                        style="width: 100%"
                        border
                      >
                        <el-table-column
                          type="index"
                          label="序号"
                          width="60"
                          align="center"
                        />
                        <el-table-column
                          prop="userName"
                          label="人员名称"
                          width="140"
                          align="center"
                        />
                        <el-table-column
                          prop="schemeNo"
                          label="方案编号"
                          width="200"
                          align="center"
                        />
                        <el-table-column
                          prop="schemeName"
                          label="方案名称"
                          width="120"
                          align="center"
                        />
                        <el-table-column
                          prop="activityDate"
                          label="活动日期"
                          width="100"
                          align="center"
                        />
                        <el-table-column
                          prop="feedbackTime"
                          label="最后审核时间"
                          width="120"
                          align="center"
                        />
                        <el-table-column
                          prop="performanceAmount"
                          label="绩效金额"
                          width="100"
                          align="center"
                        />
                        <el-table-column
                          prop="deductAmount"
                          label="扣除金额"
                          width="100"
                          align="center"
                        />
                        <el-table-column
                          label="实发绩效金额"
                          width="140"
                          align="center"
                          prop="realPerformanceAmount"
                        />
                        <el-table-column
                          prop="deductDescription"
                          label="扣除说明"
                          header-align="center"
                        />
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="provinceName"
                    label="省区名称"
                    width="120"
                    align="center"
                  />
                  <el-table-column
                    prop="cityName"
                    label="城市名称"
                    width="120"
                    align="center"
                  />
                  <el-table-column
                    prop="userName"
                    label="人员名称"
                    width="140"
                    align="center"
                  />
                  <el-table-column
                    prop="performanceTotal"
                    label="绩效合计"
                    align="center"
                  />
                  <el-table-column
                    prop="deductTotal"
                    label="扣除合计"
                    align="center"
                  />
                  <el-table-column
                    prop="realPerformanceTotal"
                    label="实发绩效合计"
                    align="center"
                  />
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="isExport"
          type="primary"
          @click="exportSummaryInfoById"
        >
          导出人员汇总
        </el-button>
        <el-button
          v-if="isExport"
          type="primary"
          @click="exportInfoById"
        >
          导出人员明细
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 权限验证
import checkPermission from '@/utils/permission'
// API
import { viewSalaryActivityPerformanceBillApi, findSummaryInfoByIdApi, exportSummaryInfoByIdApi, exportInfoByIdApi } from '@/api/v2/salaryActivityPerformanceBill'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {},
      infoListData: [],
      isExport: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.infoListData = []
        _this.isExport = false

        _this.dialogAddEditViewForm = {
          name: '',
          infoCount: 0,
          performanceTotal: 0,
          realPerformanceTotal: 0,
          deductTotal: 0,
          remark: ''
        }
        // 是否有变更权限
        if (checkPermission(['salary_activity_performance_bill_export'])) {
          _this.isExport = true
        }
        _this.loadSalaryActivityPerformanceBillData()

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadSalaryActivityPerformanceBillData () {
      let _this = this
      viewSalaryActivityPerformanceBillApi({ id: _this.dataId }).then(res => {
        const { data } = res
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        findSummaryInfoByIdApi({performanceId: _this.dataId}).then(res1 => {
            _this.infoListData = res1.data
            console.log(_this.infoListData)
        })
      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 导出数据API
    exportSummaryInfoById () {
      let _this = this;
      let excelTitleArray = '省区名称,城市名称,人员名称,绩效合计,扣除合计,实发绩效合计'.split(',')
      let excelFieldArray = 'provinceName,cityName,userName,performanceTotal,deductTotal,realPerformanceTotal'.split(',')
      exportSummaryInfoByIdApi({performanceId: _this.dataId, excelTitleArray: excelTitleArray, excelFieldArray: excelFieldArray}).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    },
    exportInfoById () {
      let _this = this;
      let excelTitleArray = '人员名称,方案编号,活动编号,活动日期,绩效金额,扣除金额,实发绩效金额,扣除说明'.split(',')
      let excelFieldArray = 'userName,schemeNo,sellId,activityDate,performanceAmount,deductAmount,realPerformanceAmount,deductDescription'.split(',')
      exportInfoByIdApi({performanceId: _this.dataId, excelTitleArray: excelTitleArray, excelFieldArray: excelFieldArray}).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
